<template>
  <section id="services" class="py-24 bg-gray-50 dark:bg-dark-bg transition-colors duration-300">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-16 max-w-3xl mx-auto">
        <h2 class="text-base font-semibold text-accent tracking-wide uppercase transition-colors duration-300">{{ t('services.subtitle') }}</h2>
        <p class="mt-2 text-3xl font-extrabold text-gray-900 dark:text-white sm:text-4xl transition-colors duration-300">{{ t('services.title') }}</p>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div
          v-for="(item, index) in tm('services.items')"
          :key="index"
          class="service-card relative flex flex-col items-center text-center bg-white dark:bg-dark-surface rounded-2xl p-8 transition-all duration-300 hover:-translate-y-2 hover:shadow-xl border border-gray-100 dark:border-indigo-900/50 hover:border-accent"
          data-animate
          :style="{ animationDelay: index * 100 + 'ms' }"
        >
          <div class="absolute top-0 left-0 right-0 h-1 bg-indigo-500 rounded-t-2xl transition-colors duration-300"></div>
          <div v-if="index === 6" class="absolute top-6 right-6">
            <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold bg-accent/10 text-accent transition-colors duration-300">
              New
            </span>
          </div>
          <div class="w-16 h-16 bg-indigo-100 dark:bg-indigo-900/30 rounded-full flex items-center justify-center mb-6 transition-colors duration-300">
            <Zap class="w-8 h-8 text-primary dark:text-accent transition-colors duration-300" />
          </div>
          <h3 class="text-xl font-bold text-gray-900 dark:text-white mb-4 transition-colors duration-300">{{ item.title }}</h3>
          <p class="text-base text-gray-600 dark:text-gray-400 leading-relaxed transition-colors duration-300">{{ item.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { Zap } from 'lucide-vue-next'
import useAnimateOnScroll from '@/composables/useAnimateOnScroll'

const { t, tm } = useI18n({ useScope: 'global' })
const { observeElements } = useAnimateOnScroll(null, { animateClass: 'animate-in' })

onMounted(() => {
  observeElements('.service-card')
})
</script>
